
import axios from 'axios';
import API from '@/common/API.js';
import router from '@/router/index.js';
import { client, imageClient } from '@/api/client.js';
import { ENDPOINTS } from '@/api/endpoints.js';

const getUrlParams = function () {
    const params = {};
    window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value, ) {
        params[key] = value;
    });
    return params;
};

const ORIGIN_URL =
    getUrlParams().debug && getUrlParams().debug === '1' ?
    process.env.VUE_APP_API_URL_DEV :
    process.env.VUE_APP_API_URL_ORGIN;
export default ({

    actions: {

        postReview({commit}, payload){
        
            return axios.post(`${ORIGIN_URL}/service/review`, payload, {}).then(res => {
                if(res.data.status===200 && res.data.message){
                    return res.data
                }else{
                    // throw 'postReview Api Res Error';
                }
            }).catch(err => {
                console.log('[[postReview]]', err);
                router.push({ name: 'Error' });
            });
        },

        postContents({commit}, payload){
            return axios.post(process.env.VUE_APP_URL_CONTENTS, payload, {}).then(res => {
                return res.data;
            }).catch(err => {
                console.log('[[postContents]]', err);
                return {status: 403};
            });
        },

        
        getCustomItemList({ commit }, { siteid }) {
            return client.get(ENDPOINTS.INIT.CUSTOM_ITEM_LIST, { params: { siteid } }).then(res => {
                if (res.data.status === 200) return res.data;
            }).catch(err => {
                console.log('[[getCustomItemList]]', err);
            });
        },

        getCustomItemDetail({ commit }, { itemKey, siteid }) {
            return client.get(`${ENDPOINTS.INIT.CUSTOM_ITEM_DETAIL}/${itemKey}`, { params: { siteid } }).then(res => {
                if (res.data.status === 200) return res.data;
            }).catch(err => {
                console.log('[[getCustomItemDetail]]', err);
            });
        },

        postCheckout({ commit }, payload) {
            return client.put(ENDPOINTS.REVIEW.SET_CHECKOUT, payload).then(res => {
                if (res.data.status === 200) {
                    return res.data;
                }
            }).catch(err => {
                console.log('[[postCheckout]]', err);
                router.push({ name: 'Error' });
            });
        },

        setImage({ commit }, payload){
            return imageClient.post(ENDPOINTS.REVIEW.IMAGE_UPLOAD, payload.data, {
                params: {
                    siteid: payload.siteid,
                    id: payload.id,
                    file: payload.file
                }
            }).then(res => {
                if(res.data.status === 200) return res.data;
            }).catch(err => {
                console.log('setImage', err)
                alert('Please try again later.');
            });
        },
    },

})
